<template>
  <div>
    <div v-if="transactions && transactions.length > 0">
      <div class="ui blue button"
           style="background-color: #092442"
           @click="showModal()">
        {{ $t('addTransaction') }}
      </div>
      <abstractTable :columns="transactionColumns" :data="computedTransactions"
                     :classes="'ui very compact center aligned celled table'">
      </abstractTable>
    </div>

    <div class="ui placeholder segment" v-else>
      <div class="ui icon header" style="color: #092442">
        <i class="dont icon"></i>
        {{ $t('noTransactionsHaveBeenAddedYet') }}
      </div>
      <div class="ui primary button" style="background-color: #092442"
           @click="showModal()">
        {{ $t('addTransaction') }}
      </div>
    </div>

    <div
      class="ui large longer modal"
      id="transaction"
      style="margin-top: 20px !important;"
    >
      <div class="header">{{ $t('addTransaction') }}</div>
      <div class="scrolling content">
        <div class="ui form" :id="'invoice-transaction' + invoiceId">
          <div class="two required fields">
            <div class="field">
              <label for="transactionAmount">{{ $t('transactionAmount') }}</label>
              <div class="ui input left icon">
                <i class="money icon"></i>
                <input
                  type="number"
                  :placeholder="$t('transactionAmount')"
                  v-model.number="transactionParams.amount"
                  name="amount"
                />
              </div>
            </div>

            <div class="field">
              <label for="paidAt">{{ $t('paidAt') }}</label>
              <div style="text-align: center" class="ui calendar" id="invoice-transaction-paid-at">
                <div class="ui input left icon">
                  <i class="calendar icon"></i>
                  <input
                    type="text"
                    :placeholder="$t('paidAt')"
                    readonly=""
                    name="day"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="required field">
            <label for="description">{{ $t('description') }}</label>
            <textarea
              :placeholder="$t('transactionAmount')"
              v-model="transactionParams.description"
              name="description"
            />
          </div>

          <div class="ui blue right floated button"
               style="background-color: #092442"
               @click="save()">
            {{ $t('save') }}
          </div>

          <div class="ui right floated button"
               @click="hideModal()">
            {{ $t('discard') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    transactions: { type: Array, default: () => { return [] } },
    invoiceId: { type: Number, required: true }
  },
  data () {
    return {
      transactionParams: {
        amount: null,
        description: null,
        paid_at: window.moment()
      }
    }
  },
  mounted () {
  },
  computed: {
    transactionColumns () {
      return [
        { header: this.$t('amount'), fieldName: 'amount', show: true, width: '8%' },
        { header: this.$t('description'), fieldName: 'description', show: true },
        { header: this.$t('paidAt'), fieldName: 'paid_at', show: true, width: '15%' }
      ]
    },
    computedTransactions () {
      let formlatedTransactions = []

      window._.each(this.transactions, transaction => {
        formlatedTransactions.push({
          id: transaction.id,
          amount: transaction.amount,
          description: transaction.description,
          paid_at: window.moment(transaction.paid_at).format('DD/MM/YYYY HH:mm')
        })
      })

      return formlatedTransactions
    },
    currentDate () {
      return window.moment().format('LLLL')
    }
  },
  methods: {
    showModal () {
      $('#transaction').modal('show').modal('refresh')
      this.initGui()
    },
    hideModal () {
      this.transactionParams = {
        amount: null,
        description: null,
        paid_at: window.moment()
      }

      $('#transaction').modal('hide')
    },
    initGui () {
      this.$nextTick(() => {
        $('#invoice-transaction-paid-at').calendar({
          type: 'datetime',
          onChange: (date) => {
            this.transactionParams.paid_at = date
          }
        })

        $('#invoice-transaction' + this.invoiceId).form({
          inline: true,
          on: 'blur',
          fields: {
            day: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, choose date.'
                }
              ]
            },
            description: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, write a description for this payment.'
                }
              ]
            },
            amount: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter patient cell phone.'
                },
                {
                  type: 'number',
                  prompt: 'Please enter valid amount.'
                }
              ]
            }
          }
        });
      })
    },
    save () {
      if ($('#invoice-transaction' + this.invoiceId).form('is valid')) {
        this.$http.post(`invoices/${this.invoiceId}/add/payment`, {
          transaction: this.transactionParams,
          clinic_id: this.getFromLocalStorage('clinicId')
        }).then(response => {
          this.transactions.push(response.data)
          this.hideModal()
        })
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/inventory_system/invoices/invoice_components/TransactionsPart.vue